// extracted by mini-css-extract-plugin
module.exports = {"container":"KcFooter_container__2rgy9","more":"KcFooter_more__2nXUQ"};